import { memo } from 'react';

function FilterOff(props) {
  const { color = '#666666', size = 16 } = props;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_213_330)">
        <path
          d="M13.1937 3.74002C13.5337 3.30002 13.2204 2.66669 12.667 2.66669H4.55371L9.86704 7.98002L13.1937 3.74002Z"
          fill={color}
        />
        <path
          d="M1.87342 1.87335L0.926758 2.81335L6.66676 8.66669V12.6667C6.66676 13.0334 6.96676 13.3334 7.33342 13.3334H8.66676C9.03342 13.3334 9.33342 13.0334 9.33342 12.6667V11.22L13.1868 15.0734L14.1268 14.1334L1.87342 1.87335Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_213_330">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(FilterOff);
